module.exports = require("https");


//////////////////
// WEBPACK FOOTER
// external "https"
// module id = 29
// module chunks = 0 1 2 3